











































import {Mixins, Prop, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import Container from "@/components/dashboard/widgets/Container.vue";
import DashboardMixin from "@/mixins/dashboard/DashboardMixin";
import NewsRepository, {News} from "@/repositories/NewsRepository";
import {Getter} from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";
import {Widget} from "@/components/dashboard/Dashboard.vue";
import _ from "lodash";

interface Style {
    [property: string]: string | number;
}

const components = {
    Container
};

@Component({components})
export default class Actus extends Mixins(DashboardMixin) {
    public dialogVisible: boolean = false;
    public selectedNews: News | null = null;
    public news: News[] = [];

    @Prop({default: null}) public widget!: Widget;
    @Getter("getCurrentOwner") public currentOwner!: Owner;

    @Watch("currentOwner", { immediate: true })
    protected onCurrentOwnerChange() {
        this.fetchNews();
    }

    protected mounted() {
        this.fetchNews();
    }

    protected fetchNews() {
        const filters = {
            ownerUuid: this.currentOwner.uuid,
            date: true
        };
        NewsRepository.get({filters})
            .then((response: object[]) => {
                if (response.length === 0) {
                    this.news = [
                        {
                            title: _.invoke(this.$options.filters, "trans", "homepageActuInComingTitle"),
                            text: _.invoke(this.$options.filters, "trans", "homepageActuInComingText")
                        }
                    ];
                    return;
                }
                this.news = response as News[];
            })
            .catch(() => {
                this.news = [];
            });
    }

    protected get containerStyle(): Style {
        return {
            padding: 0,
        };
    }

    protected pictureStyle(item: News): Style {
        return {
            backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 1)), url(${item.imageUrl})`,
        };
    }

    public truncateText(text: string, title: string = "") {
        if (text === null) {
            return "";
        }

        const maxLinesAllowed = this.calculateAvailableLines(title);
        const estimatedCharsPerLine = 60;
        const maxCharsForLines = maxLinesAllowed * estimatedCharsPerLine;

        const lineBreaks = (text.match(/\n/g) || []).length;

        const shouldTruncate = this.shouldTruncateText(text, lineBreaks, maxLinesAllowed, maxCharsForLines);

        if (shouldTruncate) {
            let truncatedText = text;

            if (lineBreaks >= maxLinesAllowed) {
                const lines = text.split("\n");
                truncatedText = lines.slice(0, maxLinesAllowed).join("\n");
            }

            if (truncatedText.length > maxCharsForLines) {
                let subString = truncatedText.slice(0, maxCharsForLines);
                const lastSpaceIndex = subString.lastIndexOf(" ");
                if (lastSpaceIndex > maxCharsForLines * 0.7) {
                    subString = subString.slice(0, lastSpaceIndex);
                }
                truncatedText = subString;
            }

            return truncatedText.replace(/\n/g, "<br />") + "...";
        }

        return text.replace(/\n/g, "<br />");
    }

    protected calculateAvailableLines(title: string): number {
        if (title.length <= 60) {
            return 3;
        } else if (title.length <= 100) {
            return 2;
        } else {
            return 1;
        }
    }

    protected shouldTruncateText(text: string, lineBreaks: number, maxLines: number, maxChars: number): boolean {
        if (lineBreaks >= maxLines) {
            return true;
        }

        if (text.length > maxChars) {
            return true;
        }

        const estimatedLines = Math.ceil(text.length / 60) + lineBreaks;
        return estimatedLines > maxLines;
    }

    protected tooLongText(text: string, title: string = "") {
        if (!text) {
            return false;
        }

        const maxLinesAllowed = this.calculateAvailableLines(title);
        const estimatedCharsPerLine = 60;
        const maxCharsForLines = maxLinesAllowed * estimatedCharsPerLine;
        const lineBreaks = (text.match(/\n/g) || []).length;

        return this.shouldTruncateText(text, lineBreaks, maxLinesAllowed, maxCharsForLines);
    }
    protected displayShowMore(news: News) {
        this.selectedNews = news;
        this.dialogVisible = true;
    }
}
